import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import { BsKey, BsBoxArrowRight } from "react-icons/bs";
import ChangePasswordScreen from "./Options/ChangePasswordScreen";
import Button from "../Button";
export default function ProfileSettingsModal({ open, user, onClose, logout, onChangePassword }) {
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return createPortal(
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-lg p-6 flex flex-col gap-6"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            {/* Nagłówek */}
            <div className="flex items-center gap-4 border-b pb-4">
              <div className="w-10 h-10 rounded-full bg-primary-700 flex items-center justify-center text-white text-md font-bold">
                {user?.name?.[0]?.toUpperCase() || "U"}
              </div>
              <div className="flex flex-col">
                <h2 className="text-xl font-semibold text-gray-800">Profil konta {user?.name}</h2>
               
              </div>
            </div>

           <div className="space-y-5">

  {/* Ustawienia */}
  <div>
    <h3 className="mb-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
      Ustawienia konta
    </h3>

    <div className="space-y-2">

      <button
        onClick={() => setChangePasswordOpen(true)}
        className="
          group
          flex
          w-full
          items-center
          gap-3
          rounded-xl
          border
          border-gray-200
          bg-white
          px-4
          py-3
          text-sm
          font-medium
          text-gray-700
          transition-all
          hover:border-indigo-200
          hover:bg-indigo-50
          hover:text-indigo-700
        "
      >
        <span
          className="
            flex
            h-9
            w-9
            items-center
            justify-center
            rounded-lg
            bg-indigo-100
            text-indigo-600
            transition
            group-hover:bg-indigo-200
          "
        >
          <BsKey className="w-5 h-5" />
        </span>

        <span className="flex-1 text-left">
          Zmień hasło
          <span className="block text-xs font-normal text-gray-400">
            Aktualizacja zabezpieczeń konta
          </span>
        </span>
      </button>


      <button
        onClick={logout}
        className="
          group
          flex
          w-full
          items-center
          gap-3
          rounded-xl
          border
          border-gray-200
          bg-white
          px-4
          py-3
          text-sm
          font-medium
          text-gray-700
          transition-all
          hover:border-red-200
          hover:bg-red-50
          hover:text-red-700
        "
      >
        <span
          className="
            flex
            h-9
            w-9
            items-center
            justify-center
            rounded-lg
            bg-red-100
            text-red-600
            transition
            group-hover:bg-red-200
          "
        >
          <BsBoxArrowRight className="w-5 h-5" />
        </span>

        <span className="flex-1 text-left">
          Wyloguj
          <span className="block text-xs font-normal text-gray-400">
            Zakończ bieżącą sesję
          </span>
        </span>
      </button>

    </div>
  </div>


  {/* Akcje */}
  <div className="
    flex
    justify-end
    border-t
    border-gray-100
    pt-4
  ">
    <Button
      onClick={onClose}
      size="small"
      variant="outlined"
      color="success"
    >
      Zamknij
    </Button>
  </div>

</div>
          </motion.div>
        </motion.div>
      )}

      {/* Modal zmiany hasła */}
      {changePasswordOpen && (
        <ChangePasswordScreen
          key="change-password-modal"
          open={changePasswordOpen}
          onClose={() => setChangePasswordOpen(false)}
          onChangePassword={onChangePassword}
        />
      )}
    </AnimatePresence>,
    document.body
  );
}
